import React from "react";
import { Select } from "antd";

const MyDropdown = ({ data, setAnswer }) => {
  const onChange = (value) => {
    setAnswer(value);
  };

  const createOptions = (options) => {
    return options?.map((item) => {
      return { value: item, label: item };
    });
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-start gap-2 mb-2">
        {data?.is_required === 1 && <p className="text-red-600 text-lg">*</p>}
        <p className="text-base text-center">{data?.field_label}</p>
      </div>

      <Select
        className="w-full h-[49px]"
        placeholder="Select option"
        options={createOptions(data?.options)}
        defaultValue={data?.response_text}
        onChange={onChange}
      />
    </div>
  );
};

export default MyDropdown;
